import {useContext, useEffect, useRef, useState} from 'react'
import { Description, Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { CategoryMaker, Maker, ModalContext } from './model';

export function MakerDialog() {
  const {openMakerDialog, setOpenMakerDialog, makers, categoryMakers, setSelectedMaker} = useContext(ModalContext)
  const [showAll, setshowAll] = useState(false)
  const categoryRefs = useRef<Record<number, HTMLDivElement|null>>({});
  useEffect(() => {
    setshowAll(false)
  }, [openMakerDialog])
  return (
    <Dialog open={openMakerDialog} onClose={() => setOpenMakerDialog?.(false)} className="relative z-1000">
      <DialogBackdrop className="fixed inset-0 bg-black/30" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="bg-white min-h-[70%] max-h-[100%] w-full md:w-[80%] min-w-[50%] xl:max-w-[60%] rounded-4xl flex flex-col items-center p-[40px] border border-grey500">
          <div className='flex flex-row items-center justify-between w-full'>
            <DialogTitle className="font-bold text-[20px]">メーカーを選択してください</DialogTitle>
            <DialogBackdrop onClick={() => setOpenMakerDialog?.(false)} className="border w-[30px] h-[30px] flex items-center justify-center border-grey500 rounded-full cursor-pointer">✕</DialogBackdrop>
          </div>
          {
            !showAll
            ?
            <>
              <div className='flex flex-row flex-wrap gap-2 mt-4 p-4 w-full overflow-y-auto'>
                {makers.map((maker: Maker) => (
                  <div className='flex flex-col items-center gap-[10px] mt-[10px]' key={maker.id}>
                    {
                      maker.logo
                      ?
                      <img
                        onClick={()=>{
                          setSelectedMaker?.(maker)
                          setOpenMakerDialog?.(false)
                        }}
                        src={maker.logo} alt={maker.title} className='border rounded-xl border-grey500 hover:border-blue-500 hover:cursor-pointer w-[100px] h-[100px] object-contain' />
                      :
                      <div className='w-[100px] h-[100px]'/>
                    }
                    <p className='text-[12px]'>{maker.title}</p>
                  </div>
                ))}
              </div>
              <button onClick={() => setshowAll(true)} className='mt-10 text-[14px] w-fit bg-grey100 rounded-2xl p-2'>すべてのメーカーを見る</button>
            </>
            :
            <>
            <div className='flex flex-row gap-8 mt-4'>
            {
              categoryMakers.map((category: CategoryMaker) => 
                <div key={category.id} className='underline cursor-pointer' onClick={() => {categoryRefs.current[category.id]?.scrollIntoView({behavior: 'smooth'})}}>{category.title}</div>
              )
            }
            </div>
            <div className='flex flex-col gap-2 mt-4 p-4 w-full overflow-y-auto'>
              <div className='flex flex-col gap-8'>
              {
                categoryMakers.map((category: CategoryMaker) => {
                  return (
                    <div ref={el=> {categoryRefs.current[category.id] = el;}} key={category.id} className='flex flex-col gap-4'>
                      <div className='flex flex-row gap-4'>
                        <p className='font-bold'>{category.title}</p>
                      </div>
                      <div className='flex flex-row gap-8'>
                      {
                        category.makers.map((maker: Maker) => (
                          <p onClick={()=>{
                            setSelectedMaker?.(maker)
                            setOpenMakerDialog?.(false)
                          }}
                            className='text-[12px] hover:underline cursor-pointer'>{maker.title}</p>
                        ))
                      }
                      </div>
                    </div>
                  )
                })
              }
              </div>
            </div>
            </>
          }
        </DialogPanel>
      </div>
    </Dialog>
  )
}